import { UploadOutlined, UnorderedListOutlined } from '@ant-design/icons';
import { Folder } from '@insight-health-ai/roseate/icons';
import { useFeatureEntitlements } from '@frontegg/react';
import { AppNavMenu } from '..';

export function useDocumentsAccess() {
  const { isEntitled } = useFeatureEntitlements('documents');
  return {
    hasAccess: !!isEntitled,
    hasWorklistAccess: !!isEntitled,
  };
}

export const useDocumentsNavMenus = (): AppNavMenu[] => {
  const { hasAccess, hasWorklistAccess } = useDocumentsAccess();

  if (!hasAccess) {
    return [];
  }

  return [
    {
      path: '/documents',
      title: 'Docs',
      icon: <Folder />,
      submenu: [
        ...(hasWorklistAccess
          ? [
              {
                path: '/documents/worklist',
                title: 'Worklist',
                icon: <UnorderedListOutlined />,
              },
            ]
          : []),
        {
          path: '/documents/bundles',
          title: 'Uploads',
          icon: <UploadOutlined />,
        },
      ],
    },
  ];
};
